import React from 'react'
import styled from 'styled-components'
import { device } from '../../config/theme/breakpoints'
import TImage from '../../assets/img/t-logo.png'

const ContainerSection = styled.div<{ hidden: boolean, fixed: boolean, classNameSection: string }>`
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content-center;
  align-items: center;
  width: 100%;
  z-index: ${p => p.fixed ? '5' : '3'};
  background: ${p => p.fixed ? 'white' : 'transparent'};
  overflow: ${p => p.hidden ? 'hidden' : 'visible'};
  position: ${p => p.fixed ? 'fixed' : 'inherit'};
  transition: 2s;

  @media ${device.laptop}{
    padding-left: 0;
    padding-right: 0;
  }

  ${p => p.classNameSection}
`

const BodyWrapper = styled.div<{ className: string, withIconLeft: boolean, withIconRight: boolean }>`
  width: 100%;
  max-width: 1100px;
  margin: auto;
  position: relative;

  ${p => p.withIconLeft ?
    `
      :after{
        content: '';
        position: absolute;
        top: 0;
        left: -32%;
        width: 30%;
        height: 90%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(${TImage});
      }
    ` : ''
  }

  ${p => p.withIconRight ?
    `
      :before{
        content: '';
        position: absolute;
        top: 0;
        right: -26%;
        width: 25%;
        height: 90%;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url(${TImage});
      }
    ` : ''
  }

  @media ${device.laptopL}{
    max-width: 1200px;
  }  

  ${p => p.className}
`
interface IOwnProps{
    full?: boolean;
    withIconLeft?: boolean;
    withIconRight?: boolean;
    className?: string
    hidden?: boolean;
    fixed?: boolean;
    children: any;
    classNameSection?: string;
}

const SectionTC: React.FunctionComponent<IOwnProps> = ({
    children,
    withIconLeft = false,
    withIconRight = false,
    className = '',
    hidden = false,
    fixed = false,
    classNameSection = ''
}) => {
  return (
    <ContainerSection hidden={!hidden} fixed={fixed} classNameSection={classNameSection}>
        <BodyWrapper
          className={className}
          withIconLeft={withIconLeft}
          withIconRight={withIconRight}
        >
            {children}
        </BodyWrapper>
    </ContainerSection>
  )
}

export default SectionTC